///jacques-andre-editeur\proshop-v2\frontend\src\components\Paginate.jsx

import { Pagination } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const Paginate = ({ pages, page, isAdmin = false, keyword = '', basePath = '' }) => {
  const navigate = useNavigate();

  const handlePageClick = (pageNumber) => {
    const path = !isAdmin
      ? keyword
        ? `/recherche/${keyword}/page/${pageNumber}`
        : `${basePath}/page/${pageNumber}`
      : `${basePath}/${pageNumber}`;
    navigate(path);
  };

  return (
    pages > 1 && (
      <Pagination>
        {[...Array(pages).keys()].map((x) => (
          <Pagination.Item
            key={x + 1}
            active={x + 1 === page}
            onClick={() => handlePageClick(x + 1)}
          >
            {x + 1}
          </Pagination.Item>
        ))}
      </Pagination>
    )
  );
};

export default Paginate;



